import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';
import { ApplicationService } from '../../shared/services/application.service';
import { Form } from 'enketo-core';
import { NgxSpinnerService } from 'ngx-spinner';
import { InspectionService } from '../shared/services/inspection.service';

declare var $: any;

@Component({
  selector: 'app-inspection-form',
  templateUrl: './inspection-form.component.html',
  styleUrls: ['./inspection-form.component.css']
})
export class InspectionFormComponent implements OnInit {

  @Input()inspectionResultID : number; 
  @Input() isPreInspection: boolean;
  @Input() inspectionIdentifier: string;
  @Output() enketoFormClosed = new EventEmitter<boolean>();
  private form: Form;

  constructor(private spinner: NgxSpinnerService, private inspectionService: InspectionService) { }

  ngOnInit() {
    this.spinner.show();

    this.inspectionService.getInspectionSubmittedResponse(this.inspectionResultID, this.isPreInspection).subscribe(resp => {
      this.spinner.hide();
      $('#enketo_container').replaceWith(resp.form);
      this.form = new Form($('form.or')[0], {
        modelStr : resp.model,
        instanceStr: resp.instance,
        submitted: true
      });

      const errors = this.form.init();
      console.log(errors);

      this.disableInputs();
  
    }, error => {
      this.spinner.hide();
      console.log(error);
    })
  }

  disableInputs() {
    $('form :input:not(:button)').each(function(x) {
      $(this).prop('disabled', true);
    });

    $('form canvas').each(function(x) {
      $(this).css('pointer-events', 'none');
    });

    $('.add-repeat-btn').each(function(x) {
      $(this).prop('disabled', true);
    });
  }  

  closeEnketoForm(){
    this.enketoFormClosed.emit(true);
  }
}
